import React from 'react';
import {connect} from 'react-redux';
import env from "../env";
import {refreshView} from 'react-admin';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from '@material-ui/core/Button';
import {downloadFile} from "./FileDownload";


const styles = {
    button: {
        margin: 1,
        width: 180
    },
}

class DownloadFileResultButton extends React.Component {

    state = {
        id: null,
        showBtn: false,
        basePath: '',
        fileExtension: '.xlsx',
    };

    constructor(props) {
        super(props);
        if (props.record) {
            this.state.id = props.record.id;
            this.state.showBtn = props.record.authStatus === 'AUTHORIZED';
            this.state.basePath = props.basePath;
            const extension = props.extension;
            if (extension) {
                this.state.fileExtension = extension
            }
        }
    }

    handleClick = (e) => {
        e.stopPropagation();
        downloadFile(this.getDownloadUrl(), this.state.id + this.state.fileExtension)
    };

    getDownloadUrl() {
        return `${env.baseURL}/api` + this.state.basePath + '/getResult?id=' + this.state.id;
    };

    render() {
        return (
            <div>
                {this.state.showBtn &&
                <Button color="primary" style={styles.button}
                        onClick={this.handleClick}>
                    <GetAppIcon/> File kết quả
                </Button>
                }

            </div>
        )
    }

}

export default connect(null, {refreshView})(DownloadFileResultButton);
